import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { f as forwardEvent } from './p-rUtJRH95.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { i as isOtherOption } from './p-D36toVjT.js';
import { H as HiddenHTMLSelect } from './p-BYoISW3Y.js';
import { d as defineCustomElement$e } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$d } from './p-BN9xIVU9.js';
import { d as defineCustomElement$c } from './p-D-k_i6-R.js';
import { d as defineCustomElement$b } from './p-DZKBv4tL.js';
import { d as defineCustomElement$a } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$9 } from './p-D4xpFZtu.js';
import { d as defineCustomElement$8 } from './p-BkDQJ61k.js';
import { d as defineCustomElement$7 } from './p-Cy8qWWQl.js';
import { d as defineCustomElement$6 } from './p-DLWyhg_S.js';
import { d as defineCustomElement$5 } from './p-B6RR6Z8w.js';
import { d as defineCustomElement$4 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$3 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

const checkListInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;min-width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiCheckListInput = /*@__PURE__*/ proxyCustomElement(class WuiCheckListInput extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * Options
         */
        this.options = [];
        /**
         * If disabled
         */
        this.disabled = false;
        this.handleInput = (e, option) => {
            // Stop the inner input event from bubbling up
            e.stopPropagation();
            const val = toValue(option);
            if (typeof val === 'undefined') {
                return;
            }
            if (this.value?.includes(val)) {
                this.value = this.value.filter((v) => v !== val);
            }
            else {
                this.value = [...(this.value ?? []), val];
            }
            this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
        };
    }
    render() {
        return (h(Host, { key: 'e9f59a3c548521882d50384afbc76c1131ce163b' }, h(HiddenHTMLSelect, { key: '3cbb83f998f4c33cd6515607176405484a99bfad', disabled: this.disabled, options: this.options, value: this.value, name: this.name, multiple: true }), h("wui-list", { key: 'a5403def645f2cec2d81f29ca70f3132373ff866', ...this.list, onFocus: (e) => {
                forwardEvent(e, this.elm);
            }, onBlur: (e) => {
                forwardEvent(e, this.elm);
            } }, this.options?.map((option, idx) => {
            if (isOtherOption(option)) {
                switch (option.type) {
                    case 'header':
                        return h("wui-list-item-header", { key: idx, ...option });
                    case 'divider':
                        return h("wui-list-item-divider", { key: idx });
                    case 'meta':
                        return h("wui-list-item-meta", { key: idx, ...option });
                }
            }
            const isOptionChecked = (this.value || []).includes(`${toValue(option)}`);
            const isOptionDisabled = typeof option === 'object' && option.disabled;
            return (h("wui-list-item", { key: idx, ...(typeof option === 'object' ? option : {}), checkable: true, checked: isOptionChecked, disabled: this.disabled || isOptionDisabled, onInput: (e) => this.handleInput(e, option), label: toLabel(option) }));
        }))));
    }
    get elm() { return this; }
    static get style() { return checkListInputCss; }
}, [257, "wui-check-list-input", {
        "value": [1040],
        "options": [16],
        "name": [1],
        "list": [16],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-check-list-input", "wui-box", "wui-check-input", "wui-divider", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiCheckListInput);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiCheckListInput as W, defineCustomElement as d };
